import { alpha, Step, StepConnector, StepLabel, styled } from '@mui/material';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { theme } from 'v3/styles/global-styles';
import { IStyledStepConnectorProps } from './interfaces';

export const StepStyled = styled(Step)(() => ({
  '& .Mui-disabled': {
    svg: { color: alpha(theme.palette.details.main, 0.5) },
  },

  '& .Mui-completed': {
    svg: { color: theme.palette.details.main },
  },

  '& .Mui-active': {
    svg: { color: theme.palette.details.main },
  },

  '& .Mui-error': {
    svg: { color: theme.palette.error.main },
  },

  '& .MuiStepLabel-iconContainer': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2rem',
    height: '3rem',
    margin: '0',
    padding: '0',
  },

  '& .MuiStepContent-root': {
    border: 'none',
    margin: 0,

    svg: {
      color: theme.palette.orange.light,
    },

    '& .Mui-disabled': {
      svg: { color: alpha(theme.palette.details.main, 0.5) },
    },
  },

  text: {
    fill: theme.palette.primary.dark,
  },

  '& .MuiStepLabel-root': {
    padding: 0,
  },
}));

export const StepLabelStyled = styled(StepLabel)(() => ({
  padding: '1rem',
}));

export const StepConnectorStyled = styled(StepConnector)<IStyledStepConnectorProps>(({ showBorder }) => ({
  '&.MuiStepConnector-vertical': {
    marginLeft: '0.875rem',
    borderLeft: showBorder ? '' : `1px solid ${theme.palette.common.white}`,
  },

  span: {
    display: 'none',
  },
}));

export const AlignColumn = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem',
}));

export const AlignRow = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '1rem',
  alignItems: 'center',
}));

export const StepComponent = styled('div')(() => ({
  width: '100%',
}));
export const SubtitleLargeCustom = styled(SubtitleLarge)(({ theme }) => ({
  paddingLeft: '1rem',
  color: theme.palette.common.white,
}));

export const SubLabelStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  textAlign: 'left',
  color: theme.palette.secondary.light,
  padding: '0.5rem 2.75rem',
}));
